import { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import { IllustrationTime } from '@vs-online-only-app/ui';

const AssociatePendingApplicationPlaceholder: FC = () => (
  <Stack gap={2} alignItems="center">
    <IllustrationTime />
    <Stack gap={1} alignItems="center">
      <Typography variant="h6" align="center">
        Your account is waiting for approval.
      </Typography>
      <Typography align="center" variant="body2">
        When you've been approved, you can start chatting with customers. Please
        contact your manager if you have been waiting for too long.
      </Typography>
    </Stack>
  </Stack>
);

export default AssociatePendingApplicationPlaceholder;
